import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { Select } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import { getSpecMedGroupsGroups, getSpecMedGroupsStudents, } from '../../../actions/medCenter/specMedGroups'

import Table from '../../../components/Table'
import Button from '../../../components/Button'
import { createMethodAssocMids } from '../../../actions/methodAssoc'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, handleChangeStudents, selectedStudents, listMids, methodAssoc }) {

  const dispatch = useDispatch()
  const { listPeople } = useSelector(state => state.method_assoc)

  const [selected, setSelected] = useState(null)

  useEffect(() => {

  }, [selected])


  const renderLi = (data) => {
    const { fio, mid } = data
    return (
      <tr>
        <td
          onClick={() => handleChangeStudents(data)}
          style={{ backgroundColor: [...selectedStudents, ...listMids]?.find(el => (el.mid == mid)) ? '#3689FF' : '' }}
        >
          {fio}
        </td>
      </tr >
    )
  }

  const handleSubmit = () => {
    const onlyMids = [...selectedStudents, ...listMids]?.map(el => el.mid)
    // state = 'level'  зачем-то нужен... невыяснено)
    dispatch(createMethodAssocMids({ mid: onlyMids, maid: methodAssoc.maid, state: 'level' }))
    closeModal()
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <Table className={styles.table} >
              <thead>
                <tr>
                  <th>ФИО</th>
                </tr>
              </thead>
              <tbody>
                {listPeople?.map(renderLi)}
              </tbody>
            </Table>
          </div>
        </div>
        <div className={styles.inputsRow}>
          <Button style={{ margin: '0 auto 20px' }} onClick={handleSubmit}>Сохранить</Button>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Отменить</Button>
        </div>
      </>
    </Modal>

  )
}
